import httpRequest from '@/services/httpRequest.js'

export default ({
  namespaced: true,
  state: {
    isLoading: false,
    selectedSemester: null,
    isHomeroomTeacher: false,
    homeroomClassroom: null,
    eRaporData: null,
    students: [],
  },
  actions: {
    async isHomeroomTeacher({ rootState, state }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/erapor/is_homeroom_teacher`,
          method: 'GET',
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      if (resp.status === 200) {
        state.isHomeroomTeacher = resp.data.is_homeroom_teacher;
        state.homeroomClassroom = resp.data.classroom;
      }
    },
    async initiateErapor({ rootState }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/erapor/initiate`,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      return resp
    },
    async getErapor({ rootState }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/erapor/get_erapor`,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      return resp
    },
    async getStudents({ rootState }, params) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/eraporstudent`,
          method: 'GET',
          params: params,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      return resp
    },
    async getEraporStudent({ rootState }, raporId) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/eraporstudent/${raporId}`,
          method: 'GET',
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      // console.log('RESSSSSSP GET', resp, resp.data)
      return resp
    },
    async editEraporStudent({ rootState }, {raporId, data}) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/eraporstudent/${raporId}`,
          method: 'PATCH',
          data: data,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      // console.log('RESSSSSSP PATCH', resp, resp.data)
      return resp
    },
    async seenEraporStudent({ rootState }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/eraporstudent/seen`,
          method: 'POST',
          data: data,
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      // console.log('RESSSSSSP', resp, resp.data)
      return resp
    },
    async downloadEraporStudent({ rootState }, raporId) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/eraporstudent/${raporId}/download`,
          method: 'GET',
        },
        authorized: true,
      }
      const resp = await httpRequest(payload)
      // console.log('RESSSSSSP', resp, resp.data)
      return resp
    },
  },
  getters: {
  }
})